'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canReadText = canReadText;
exports.getTextColor = getTextColor;
exports.getPrimaryColorOrDefault = getPrimaryColorOrDefault;

var _colors = require('HubStyleTokens/colors');

function getL(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  var r = parseInt(result[1], 16) / 255.0;
  var rL = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  var g = parseInt(result[2], 16) / 255.0;
  var gL = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  var b = parseInt(result[3], 16) / 255.0;
  var bL = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  return 0.2126 * rL + 0.7152 * gL + 0.0722 * bL;
}

function canReadText(backgroundHex, textColor) {
  var backL = getL(backgroundHex);
  var textL = getL(textColor);

  var contrastRatio = (textL + 0.05) / (backL + 0.05);

  return contrastRatio > 2.0;
}

function getTextColor(primaryColor) {
  return canReadText(primaryColor, _colors.OLAF) ? _colors.OLAF : _colors.OBSIDIAN;
}

/*
 * Util function to determine the color of text to display against a white
 * background. If the primaryColor is dark enough to render against a white
 * background, use it. Otherwise, use the element's default coloring
*/
function getPrimaryColorOrDefault(primaryColor) {
  return canReadText(primaryColor, _colors.OLAF) ? primaryColor : null;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/utils/color.js
// module id = 58
// module chunks = 0